<template>
	<div>
		<Header :logo="`${imgPath}/static/assets/img/brand/1/logo.png`" :width="2.69" />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/brand/1/banner.jpg`" />
			<cloud />
		</div>
		<div class="brandWrap brand1" :class="{'zh-cn': lang=='zh-cn','en-us':lang == 'en-us'}">
			<div class="brandWrapModule" :class="{'zhw': lang=='zh-cn','letterSpace': lang == 'en-us'}">
			<p class="field_1" :class="{'item_center': lang=='zh-cn'}" v-html="detail.field_1"></p>
			<p class="field_2" :class="{'item_center': lang=='zh-cn'}" :style="{ 'marginTop': lang=='zh-cn'? '0.59rem' : '0.68rem' }" v-html="detail.field_2"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.53rem' : '0.95rem' }"><img :src="detail.field_3" width="100%" /></p>
			<div class="brandWrapModule" :class="{'letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.87rem' : '1.18rem' }">
				<p class="field_1" v-html="detail.field_4"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.24rem' : '0.68rem' }" v-html="detail.field_5"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.48rem' : '0.89rem' }"><img :src="detail.field_6" width="100%" /></p>
			<div class="brandWrapModule" :class="{'letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '1.78rem' : '1.84rem' }">
				<p class="field_1" v-html="detail.field_7"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.76rem' : '0.68rem' }" v-html="detail.field_8"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.15rem' : '1.42rem' }"><img :src="detail.field_9" width="100%" /></p>
			<p class="brandImg_style2" style="margin-top:1.71rem"><img :src="detail.field_10" width="100%" /></p>
			<div class="brandWrapModule" :class="{'letterSpace': lang == 'en-us'}" style="padding-left:0.33rem" :style="{ 'marginTop': lang=='zh-cn'? '1.7rem' : '1.12rem' }">
				<p class="field_1" v-html="detail.field_11"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.76rem' : '0.68rem' }" v-html="detail.field_12"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1rem' : '0.87rem' }"><img :src="detail.field_13" width="100%" /></p>
			<a class="brandLinkWrap" href="http://www.hlamall.cn" target="_blank">
				<p class="brandLink1">{{ $t('shopname') }}</p>
				<p class="brandLink2">www.hlamall.cn</p>
				<img class="linkIcon" :src="`${imgPath}/static/assets/img/brand/linkImg.png`" />
			</a>
			<top />
			<div class="cloudImg">
				<img :src="`${imgPath}/static/assets/img/cloud.png`" />
			</div>
			<bottom />
		</div>
	</div>
</template>
<script>
export default {
    data(){
		return{
			detail:{},
			lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
		}
	},
	async mounted() {
		let res = await this.$util.getBrandDetail(8)
		this.detail = res;
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/brandStyle.scss";
</style>


// WEBPACK FOOTER //
// src/views/brand/brand1.vue